import React, { useMemo } from 'react';
import StarRatingCell from './star-rating-cell';
import { Star } from './star-rating-types';
import { StarRatingCellsContainer, Container, RatingSnippet } from './star-rating-styles';
// Function used to get Array of length maxRating with every value indicating rating value( 0|1|2 ) of that index
var _getStarRatingArray = function (actualRating, maxRating) {
    // If this case happens, then it's a bug. But handle gracefully!
    if (actualRating > maxRating) {
        actualRating = maxRating;
    }
    var starRatingArray = [];
    for (var i = 1, range = Math.ceil(actualRating) - 1; i <= range; i += 1) {
        starRatingArray.push(Star.FULL_STAR);
    }
    if (actualRating === Math.ceil(actualRating)) {
        starRatingArray.push(Star.FULL_STAR);
    }
    else if (actualRating >= Math.ceil(actualRating) - 0.5) {
        starRatingArray.push(Star.HALF_STAR);
    }
    else {
        starRatingArray.push(Star.EMPTY_STAR);
    }
    for (var i = Math.ceil(actualRating) + 1; i <= Math.floor(maxRating); i += 1) {
        starRatingArray.push(Star.EMPTY_STAR);
    }
    return starRatingArray;
};
var StarRating = function (_a) {
    var actualRating = _a.actualRating, maxRating = _a.maxRating, customFullStar = _a.customFullStar, customEmptyStar = _a.customEmptyStar, customHalfStar = _a.customHalfStar, _b = _a.showNumericRating, showNumericRating = _b === void 0 ? true : _b, _c = _a.shouldCenterAlignIcons, shouldCenterAlignIcons = _c === void 0 ? false : _c;
    var starRatingArray = useMemo(function () { return _getStarRatingArray(actualRating, maxRating); }, [actualRating, maxRating]);
    return (React.createElement(Container, null,
        React.createElement(StarRatingCellsContainer, { shouldCenterAlignIcons: shouldCenterAlignIcons }, starRatingArray.map(function (starRating, index) { return (React.createElement(StarRatingCell, { key: index, rating: starRating, customEmptyStar: customEmptyStar, customHalfStar: customHalfStar, customFullStar: customFullStar })); })),
        showNumericRating && (React.createElement(RatingSnippet, null,
            actualRating,
            "\u00A0/\u00A0",
            maxRating))));
};
export default StarRating;
